import { css } from "styled-components"

// Margins
const margin = {
  small: "8px",
  medium: "16px",
  large: "24px",
}

const marginForDirection = (direction, marginValue) => {
  const marginValues = Object.keys(margin)
  if (["top", "left", "bottom", "right"].indexOf(direction) < 0) {
    return 0
  }

  switch (typeof marginValue) {
    case "string":
      if (marginValues.indexOf(marginValue) > -1) {
        return margin[marginValue]
      }
      return 0
    case "object":
      if (marginValues.indexOf(marginValue[direction]) > -1) {
        return margin[marginValue[direction]]
      }
      return 0
    default:
      return 0
  }
}

const MarginContainer = css`
  margin: ${props =>
    `${marginForDirection("top", props.margin)} 
     ${marginForDirection("right", props.margin)} 
     ${marginForDirection("bottom", props.margin)} 
     ${marginForDirection("left", props.margin)}`};
`

MarginContainer.defaultProps = {
  margin: "",
}

export default MarginContainer
